import { RestrictedAccountObjectDto } from "../restricted-account-object/restricted-account-object.dto";
import { DtoInclude, DtoIncludeNumber, DtoRef } from "../../../core/store/dto/dto";
import { Field } from "../field/field.model";

export class JobDto extends RestrictedAccountObjectDto {
    @DtoInclude
    reference: string;
    @DtoInclude
    jobDate: string;
    @DtoRef
    jobType: string;

    billable: string;
    fields: Array<string>;
    files: Array<string>;

    @DtoRef
    jobStatus: string;

    version: number;
    @DtoInclude
    assigneeName: string;
    @DtoRef
    assigneeId: string;

    @DtoIncludeNumber
    timeZoneOffset: number;
    @DtoIncludeNumber
    pendingFields: number;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job/job.dto.ts